import React from "react";
import { useTranslation } from "react-i18next";
import { isMobileOnly } from "react-device-detect";
import { StyledFilters, StyledLoupeDiv } from "../styledComponents/StyledIndex";
import {
  MobileFilter,
  StyledFilterButton,
  StyledFilterOption,
} from "../styledComponents/StyledGamesCategories";
import { StyledSelect } from "../styledComponents/CommonStyledComponents";

const SportsBookCategories = ({
  serverSetup,
  skin,
  pages,
  onToggleSearchShow,
}) => {
  const { t, i18n } = useTranslation("");
  const providerSearchFlag = false;
  const selected = "sports-book";
  const baseUrl = "/" + i18n.language;
  const categories = serverSetup.gameCategories;
  const categorySelected = (category) =>
    selected && selected.toLowerCase() === category;

  const handleChange = (event) => {
    var unsafeSearchTypeValue = event.target.value
      .toLowerCase()
      .replace(/ /g, "-");
    if (event.target.value === "all") {
      window.location.replace(
        skin === "pub" || skin === "rac" || skin === "cac" || skin === "hyc"
          ? pages["games"]
          : pages["index"]
      );
    } else {
      window.location.replace(baseUrl + "/" + unsafeSearchTypeValue);
    }
  };

  return (
    <StyledFilters>
      {isMobileOnly ? (
        <MobileFilter sportsbook>
          <label htmlFor="filter-select">{t("label_filter", "Filter:")}</label>{" "}
          <StyledSelect
            formControll
            id="filter-select"
            value={selected && selected.replace("-", " ")}
            onChange={(e) => handleChange(e)}
          >
            {skin !== "plc" && skin !== "bnk" && (
              <StyledFilterOption
                value="all"
                selected={selected === null && !providerSearchFlag}
              >
                {t("label_all_categories", "All")}
              </StyledFilterOption>
            )}
            {categories &&
              categories.map(
                (category) =>
                  (category.isVisible || category.name === "Sports Book") && (
                    <StyledFilterOption
                      opened={
                        categorySelected(category.name) ||
                        selected ===
                          category.name.toLowerCase().replace(/ /g, "-")
                      }
                      value={category.name.toLowerCase()}
                      key={category.title}
                    >
                      {t(`${category.title}`)}
                    </StyledFilterOption>
                  )
              )}
          </StyledSelect>
        </MobileFilter>
      ) : (
        <>
          <StyledFilterButton
            opened={providerSearchFlag ? false : !selected}
            onClick={() =>
              window.location.replace(
                skin === "pub" || skin === "rac" || skin === "yak"
                  ? pages["games"]
                  : pages["index"]
              )
            }
          >
            {t("label_all_categories", "All Categories")}
          </StyledFilterButton>
          {categories &&
            categories.map(
              (category) =>
                category.isVisible &&
                category.name !== "Sports Book" && (
                  <StyledFilterButton
                    opened={
                      categorySelected(category.name) ||
                      selected ===
                        category.name.toLowerCase().replace(/ /g, "-")
                    }
                    value={category.name.toLowerCase()}
                    key={category.title}
                    onClick={() =>
                      window.location.replace(
                        baseUrl +
                          "/" +
                          category.name.toLowerCase().replace(/ /g, "-")
                      )
                    }
                  >
                    {t(`${category.title}`)}
                  </StyledFilterButton>
                )
            )}
          <StyledFilterButton opened={true}>
            {t("label_sports_book", "sports book")}
          </StyledFilterButton>
          {skin === "rac" && <StyledLoupeDiv onClick={onToggleSearchShow} />}
        </>
      )}
    </StyledFilters>
  );
};

export default SportsBookCategories;
